import { useRouter } from "next/router";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

function Rating({ t, ratings }) {
  const { locale } = useRouter();
  return ratings?.length > 0 && (
    <div className="p-4 my-6 bg-white rounded-lg">
      <div className="flex items-center justify-between pb-3 mb-3 bg-white border-b rounded-md">
        <h3 className="text-2xl font-semibold text-red ">{t("Ratings")}</h3>
        
      </div>
      {ratings?.length > 0 ? (
        <div className="py-7 flex border-b max-[991px]:flex-col">
          <div
            className={`px-4 flex-1 ${
              locale == "en" ? "border-l" : "border-r"
            } max-[991px]:my-5 max-[991px]:px-0 max-[991px]:border-0`}
          >
            <div className="flex items-center justify-center">
              <button className="p-2 text-white rounded-full bg-red">
                <AiOutlineStar size="24px" />
              </button>
              <h2 className="mx-2 text-lg font-semibold text-zinc-600">
                {t("HowCanYouRateProduct?")}
              </h2>
            </div>
            <p className="my-3 text-center text-zinc-600">{t("Answer")}</p>
          </div>
        </div>
      ) : (
        ""
      )}
      {ratings?.map((rating, idx) => (
        <div key={idx} className="border-b py-7">
          <div className="flex items-center">
            <div className="flex items-center justify-center font-semibold rounded-full h-11 w-11 bg-emerald-100 text-emerald-600">
              {rating?.nickname[0]}
            </div>
            <div className="mx-4">
              <h4 className="mb-1 text-lg font-semibold">{rating?.nickname}</h4>
              <div className="flex items-center">
                {[...Array(5).keys()].map((i) => (
                  <AiFillStar
                    key={i}
                    size="19px"
                    className="mr-1 -rotate-45 text-darkgold"
                  />
                ))}
              </div>
            </div>
          </div>
          <p className="p-2">{rating?.detail}</p>
        </div>
      ))}
      {!ratings?.length ? (
        <div className="flex items-center justify-center h-24 p-2 font-semibold bg-white border rounded-md text-zinc-600">
          {t("NoRatings")}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default Rating;
